export var CheckoutSdkType;
(function (CheckoutSdkType) {
    CheckoutSdkType["Element"] = "element";
    CheckoutSdkType["DropIn"] = "drop-in";
})(CheckoutSdkType || (CheckoutSdkType = {}));
//# sourceMappingURL=checkout-sdk-type.js.map